import { render, staticRenderFns } from "./AppPanel.vue?vue&type=template&id=8f0d1272&scoped=true&"
import script from "./AppPanel.vue?vue&type=script&lang=js&"
export * from "./AppPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppPanel.vue?vue&type=style&index=0&id=8f0d1272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0d1272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0d1272')) {
      api.createRecord('8f0d1272', component.options)
    } else {
      api.reload('8f0d1272', component.options)
    }
    module.hot.accept("./AppPanel.vue?vue&type=template&id=8f0d1272&scoped=true&", function () {
      api.rerender('8f0d1272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AppPanel.vue"
export default component.exports